import { render } from "./AllProduct.vue?vue&type=template&id=335fb058&scoped=true"
import script from "./AllProduct.vue?vue&type=script&lang=js"
export * from "./AllProduct.vue?vue&type=script&lang=js"

import "./AllProduct.vue?vue&type=style&index=0&id=335fb058&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-335fb058"]])

export default __exports__